export const API_ADMIN = '/admin-rest-api/'
